import { render } from "./SearchSvg.vue?vue&type=template&id=2c89f4fa&ts=true"
import script from "./SearchSvg.vue?vue&type=script&lang=ts"
export * from "./SearchSvg.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__